import { useContext, useMemo } from 'react'
import { FieldError, UseFormRegister, UseFormSetValue } from 'react-hook-form'

import { AutocompleteOption } from '@lib/dom'
import { compareStrings } from '@lib/helpers'
import { InstitutionContext } from '@lib/institution-context'
import { PrintShopFormStringsContext } from '@lib/print/print-shop-form-strings-context'
import {
  ShopFormShopStepShopValues,
  ShopFormShopStepValues,
} from '@lib/print/types'

import InputField from '@components/input-field/with-form-register'
import InputWithAutocomplete from '@components/input-with-autocomplete'

interface ShopStepShopFormProps {
  register: UseFormRegister<ShopFormShopStepValues>
  setValue: UseFormSetValue<ShopFormShopStepValues>
  defaultValues: ShopFormShopStepShopValues
  errors: {
    shopName?: FieldError
    institutionName?: FieldError
  }
}

const ShopStepShopForm = ({
  register,
  setValue,
  defaultValues,
  errors,
}: ShopStepShopFormProps) => {
  const { institutions } = useContext(InstitutionContext)
  const { shopFormStrings } = useContext(PrintShopFormStringsContext)

  const autocompleteOptions = useMemo(() => {
    return institutions
      .filter((institution) => institution.isPublic)
      .map((institution) => {
        const autocompleteOption: AutocompleteOption = {
          value: institution.id,
          title: institution.name,
        }

        return autocompleteOption
      })
      .sort((option1, option2) => compareStrings(option1.title, option2.title))
  }, [institutions])

  const shopNameRegister = register('shopName', {
    required: shopFormStrings.shopFormNameMissing,
  })
  const institutionNameRegister = register('institutionName', {
    required: shopFormStrings.shopFormSchoolMissing,
  })

  return (
    <div className="space-y-4">
      <InputField
        type="text"
        formRegister={shopNameRegister}
        errorMessage={errors.shopName?.message}
        label={shopFormStrings.shopFormName}
        defaultValue={defaultValues.shopName}
        placeholder={shopFormStrings.shopFormNamePlaceholder}
        hasCustomInputStyles
        inputWrapperClassName="py-2 px-4 border border-gray-light rounded bg-white"
        inputClassName="text-base leading-snug bg-white"
        labelClassName="mb-2 font-semibold"
      />

      <InputWithAutocomplete
        type="text"
        onChange={(newValue) => {
          setValue(institutionNameRegister.name, newValue)
        }}
        autocompleteOptions={autocompleteOptions}
        errorMessage={errors.institutionName?.message}
        label={shopFormStrings.shopFormSchool}
        defaultValue={defaultValues.institutionName}
        placeholder={shopFormStrings.shopFormSchoolPlaceholder}
        hasCustomInputStyles
        inputWrapperClassName="py-2 px-4 border border-gray-light rounded bg-white"
        inputClassName="text-base leading-snug bg-white"
        labelClassName="mb-2 font-semibold"
      />
    </div>
  )
}

export default ShopStepShopForm
